module.exports = __webpack_public_path__ + "img/jcb.15c05fcf.png";